import { render, staticRenderFns } from "./ImageUploader.vue?vue&type=template&id=248a77ec"
import script from "./ImageUploader.vue?vue&type=script&lang=js"
export * from "./ImageUploader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports